<div class="flex flex-grow flex-row gap-1">
  @if (showCreate()) {
    <ag1-button
      variant="secondary"
      (clickEvent)="handleCreateClick()"
      tooltip="Create New"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="h-5 w-5"
      >
        <path
          d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
        />
      </svg>
    </ag1-button>
  }
  @if (showDuplicate()) {
    <ag1-button
      variant="secondary"
      (clickEvent)="handleDuplicateClick()"
      tooltip="Create Copy"
      [disabled]="!selectedReport"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="h-5 w-5"
      >
        <path
          d="M7 3.5A1.5 1.5 0 018.5 2h3.879a1.5 1.5 0 011.06.44l3.122 3.12A1.5 1.5 0 0117 6.622V12.5a1.5 1.5 0 01-1.5 1.5h-1v-3.379a3 3 0 00-.879-2.121L10.5 5.379A3 3 0 008.379 4.5H7v-1z"
        />
        <path
          d="M4.5 6A1.5 1.5 0 003 7.5v9A1.5 1.5 0 004.5 18h7a1.5 1.5 0 001.5-1.5v-5.879a1.5 1.5 0 00-.44-1.06L9.44 6.439A1.5 1.5 0 008.378 6H4.5z"
        />
      </svg>
    </ag1-button>
  }
  @if (showDelete()) {
    <ag1-button
      variant="secondary"
      (clickEvent)="handleDeleteClick()"
      [disabled]="
        !selectedReport || selectedReport.readonly || reports.length === 1
      "
      tooltip="Delete"
    >
      <!-- project icon here -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </ag1-button>
  }
  @if (showSave()) {
    <ag1-button
      variant="secondary"
      tooltip="Save"
      (clickEvent)="handleSaveClick()"
      [disabled]="
        !selectedReport || selectedReport.readonly || !selectedReport.dirty
      "
    >
      <svg
        viewBox="0 0 32 32"
        class="h-5 w-5"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m30.71 7.29-6-6a1 1 0 0 0 -.71-.29h-2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2-2v-8h-6a3 3 0 0 0 -3 3v24a3 3 0 0 0 3 3h2v-9a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v9h2a3 3 0 0 0 3-3v-20a1 1 0 0 0 -.29-.71z"
        />
        <path d="m12 1h8v8h-8z" />
        <path d="m23 21h-14a1 1 0 0 0 -1 1v9h16v-9a1 1 0 0 0 -1-1z" />
      </svg>
    </ag1-button>
  }

  @if (showRename()) {
    <ag1-button
      variant="secondary"
      (clickEvent)="handleRenameClick()"
      tooltip="Rename"
      [disabled]="!selectedReport || selectedReport.readonly"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="h-5 w-5"
      >
        <path
          d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z"
        />
        <path
          d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z"
        />
      </svg>
    </ag1-button>
  }
  <ng-select
    class="min-w-min max-w-[12rem]"
    [(ngModel)]="selectedReport"
    (change)="handleReportChange($event)"
    [clearable]="false"
  >
    @for (report of reports; track report) {
      <ng-option [value]="report"
        >{{ report.dirty ? "*" : "" }}{{ report.name }}
      </ng-option>
    }
  </ng-select>
  @if (selectedReport) {
    <ng-select
      class="min-w-min max-w-[12rem]"
      [(ngModel)]="selectedReport.visibility"
      (change)="handleVisibiltyChange($event)"
      [clearable]="false"
    >
      <ng-option [value]="'Private'">Private </ng-option>
      <ng-option [value]="'Company'">Company </ng-option>
      @if (canSaveAsPublic()) {
        <ng-option [value]="'Public'">Public </ng-option>
      }
    </ng-select>
  }
  <div class="flex flex-grow justify-end gap-1">
    @if (selectedReport) {
      <ng-select
        class="min-w-min max-w-[5rem]"
        [(ngModel)]="selectedReport.renderer"
        (change)="handleRendererChange($event)"
        [clearable]="false"
        [disabled]="!selectedReport"
      >
        <ng-option [value]="'table'">Table </ng-option>
        <ng-option [value]="'line'">Line </ng-option>
        <ng-option [value]="'bar'">Bar </ng-option>
      </ng-select>
    }
    @if (showRename()) {
      <ag1-button
        variant="secondary"
        (clickEvent)="handleExportClick()"
        tooltip="Export To Excel"
        [disabled]="
          !selectedReport ||
          !data().length ||
          (!rows().length && !cols().length)
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-6 w-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9.75v6.75m0 0l-3-3m3 3l3-3m-8.25 6a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
          />
        </svg>
      </ag1-button>
    }
  </div>
</div>

<ng-template agModalHost />
